const apiUrl = process.env.REACT_APP_API_URL;
export const PutEscolaUsuari = async (id_permis : number, id_usuari : number , page : string , id_usu_log : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/escola/${id_usu_log}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({ id_permis, id_usuari })
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
